var render = function render(){var _vm=this,_c=_vm._self._c;return _c('e-dialog',{attrs:{"dialogTitle":"业务咨询人","centerDialogVisible":_vm.visible,"showCloseBtn":true,"showBtn":false,"popupWidth":'580px'},on:{"resetPopupData":_vm.resetPopupData}},[_c('e-table-list',{attrs:{"maxHeight":"400","table-data":_vm.list,"table-label":_vm.tableLabel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }